document.addEventListener("DOMContentLoaded", () => {
    waitForElement();
});
function waitForElement() {
    var id = ".mm-splide-slider-product-recommendation";
    var splideElem = document.querySelector(id);

    if (splideElem != null && splideElem.querySelectorAll(".splide__slide") != null) {
        mmSplideInit(splideElem);
    } else {
        setTimeout(waitForElement, 2000);
    }
}

function mmSplideInit(splideElem) {
    new Splide(splideElem, {
        type: "slide",
        arrows: true,
        pagination: false,
        gap: 25,
        perPage: 4,
        breakpoints: {
            768: {
                perPage: 2,
                arrows: false,
                gap:8,
                padding: {
                    right: 30,
                },
            },
        },
    }).mount();
}
